import { List } from 'antd';
import styled from 'styled-components';

const ListSelect = styled(List)``;

export default { ListSelect };
